import { render, staticRenderFns } from "./PopTip.vue?vue&type=template&id=14516a06&scoped=true&"
import script from "./PopTip.vue?vue&type=script&lang=js&"
export * from "./PopTip.vue?vue&type=script&lang=js&"
import style0 from "./PopTip.vue?vue&type=style&index=0&id=14516a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14516a06",
  null
  
)

export default component.exports